module.exports = __webpack_public_path__ + "img/email.d5437ea6.png";